<ng-container *ngIf="isVisible">
  <div class="mx-2 mt-2 comments-drawer-container">
    <div class="comments-content">
      <commentary-ui
        #commentaryEl
        source="helios"
        hide-titlebar="true"
        [attr.account-id]="effectiveAccountId"
        [attr.related-account-ids]="relatedAccountIdsAttr"
        [attr.user-id]="userId ?? null"
        [attr.user-display-name]="userDisplayName ?? null"
        [attr.transaction-id]="entityContext?.transactionId ?? null"
        [attr.ext-tran-id]="entityContext?.extTranId ?? null"
        [attr.break-id]="entityContext?.breakId ?? null"
        [attr.asset-id]="entityContext?.assetId ?? null"
        [attr.suspense-id]="entityContext?.suspenseId ?? null"
        [attr.suspense-ids]="suspenseIdsAttr"
        [attr.entity-context]="entityContextAttr"
        [attr.ref-descriptions]="entityDescriptionsJson"
        [attr.thread-ids]="threadIdsJson"
        [attr.thread-ids-seq]="threadIdsSeq"
        [attr.action]="commentaryAction ?? null"
        [attr.action-seq]="commentaryActionSeq"
        [attr.comment-id]="commentId ?? null"
      ></commentary-ui>
    </div>
  </div>
</ng-container>
